// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2nxen","icon":"SortAdornment_icon__3ulBF","up":"SortAdornment_up__3EDz8","down":"SortAdornment_down__EWb8x","active":"SortAdornment_active__2fQj3"};